import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FormFooter } from '../../../../elements/form-footer';
import { FieldError } from '../../../../elements/field-error/field-error';
import { FileInputElement } from '../../../../elements/file-input';
import { RadioGroup } from '../../../../elements/radio-group';
import { DatePicker } from '../../../../elements/date-picker';
import { SelectNumber } from '../../../../elements/select-number';
import { Select } from '../../../../elements/select';



// construccion del objeto yup de validacion del cuestionario
let obligado = {
    //cost: Yup.string().required('obligatorio'),
    start_date: Yup.mixed().required('obligatorio'),
    end_date: Yup.mixed().required('obligatorio'),
    company: Yup.mixed().required('obligatorio'),
    number: Yup.string().required('obligatorio'),
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    cost: '',
    start_date: null,
    end_date: null,
    number: '',
    company: null

};

export const SegurosTabForm = ({
    item,
    vehicleId,
    close,
    doDelete
}: {
    item?: any;
    vehicleId?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [policies, setPolicies] = useState<any | null>([]);
    const [isDeleted, setIsDeleted] = useState<boolean>(false);
    const [companies, setCompanies] = useState<any | null>([]);

    useEffect(() => {
        api('/fleet/insurance-companies/?limit=9999', 'GET');
    }, []);



    // Load initial data
    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        if (!item) {
            after.vehicle = vehicleId;
        } else {
            after.vehicle = after.vehicle.id;
        }


        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        let formdata = new FormData();

        if (enviaremos.document) {
            if (enviaremos.document.document) {
                formdata.append(
                    'document',
                    enviaremos.document.document[0],
                    enviaremos.document.document[0].name
                );
            }
        }

        for (let key in enviaremos) {
            if (key !== 'document') {
                formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
            }
        }

        if (isDeleted) {
            api(`/fleet/insurances/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            if (enviaremos.id) {
                // update

                api(`/fleet/insurances/${enviaremos.id}/`, 'PATCH', formdata, true);
            } else {
                // create

                api('/fleet/insurances/', 'POST', formdata, true);
            }
        }
    };

    const openInNewTab = () => {
        window.open(data?.display_url, '_blank', 'noreferrer');
    };



    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('insurances')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    window.location.reload();
                    close();
                }
            }
            if (state.path.includes('insurance-companies')) {
                setCompanies(state.data.results);
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            } else {
                toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">

                    <Select
                        name="company"
                        label={t('common.label.compania-aseguradora')}
                        placeholder="Select value"
                        items={companies}
                        value={values.company}
                        onChange={(value) =>
                            setFieldValue('company', value.company)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'company'}
                    />

                    <Input
                        label={t('common.label.numero-poliza')}
                        type="text"
                        placeholder={t('common.label.numero-poliza')}
                        name="number"
                        value={values.number}
                        onChange={(value) =>
                            setFieldValue('number', value.number)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'number'}
                    />


                    <Input
                        label={t('common.label.costo')}
                        type="text"
                        placeholder={t('common.label.costo')}
                        name="cost"
                        value={values.cost}
                        onChange={(value) =>
                            setFieldValue('cost', value.cost)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'cost'}
                    />

                    <div className='pt-2'>
                        <DatePicker
                            name="start_date"
                            type="date"
                            label={t(
                                'common.label.fecha-inicio'
                            )}
                            value={
                                (data
                                    ? dayjs(
                                        data.start_date
                                    ).format(
                                        'YYYY-MM-DD'
                                    )
                                    : '') ||
                                values.start_date
                            }
                            onChange={(value) => {
                                setFieldValue(
                                    'start_date',
                                    value.start_date
                                        ? dayjs(
                                            value.start_date
                                        ).format(
                                            'YYYY-MM-DD'
                                        )
                                        : null
                                );
                            }}
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'start_date'}
                        />
                    </div>

                    <div className='pt-2'>
                        <DatePicker
                            name="end_date"
                            type="date"
                            label={t(
                                'common.label.fecha-fin'
                            )}
                            value={
                                (data
                                    ? dayjs(
                                        data.end_date
                                    ).format(
                                        'YYYY-MM-DD'
                                    )
                                    : '') ||
                                values.end_date
                            }
                            onChange={(value) => {
                                setFieldValue(
                                    'end_date',
                                    value.end_date
                                        ? dayjs(
                                            value.end_date
                                        ).format(
                                            'YYYY-MM-DD'
                                        )
                                        : null
                                );
                            }}
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'end_date'}
                        />
                    </div>

                    <div className='pt-8'>
                        {data?.document ? <div className='flex'>
                            {!isDeleted ? <div className='flex cursor-pointer' onClick={openInNewTab}>
                                <span className='border border-gray-400 rounded py-2 px-4 text-sm'>{t('common.label.ver-document')}</span>
                            </div> : ''}
                            {!isDeleted ? <div className='flex cursor-pointer ml-8' onClick={() => {
                                setFieldValue('document', null);
                                setFieldValue('display_url', null);
                                setIsDeleted(true);
                            }}>
                                <span className='border border-red-500 rounded p-2 text-sm text-red-500'>{t('common.button.delete-document')}</span>
                            </div> : ''}
                        </div> : ''
                        }
                    </div>

                    <div className='w-full pb-8 pt-4'>
                        <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.document ? t('common.label.cambiar-document') : t('common.form-label.documento')}</span>
                        <FileInputElement
                            name="document"
                            onChange={(value) => {
                                // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                setFieldValue('document', value);
                            }}
                        />
                    </div>





                    <div className='pt-48'></div>


                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};